export const PROPERTY_DESCRIPTION_SECTION = 'propertyDescription';
export const PROPERTY_DESCRIPTION_ITEM = 'descricaoImovel';
export const PROPERTY_DESCRIPTION_MAX_LENGTH = 500;
